import { render, staticRenderFns } from "./GyroscopeMaze.vue?vue&type=template&id=6310d924&scoped=true&"
import script from "./GyroscopeMaze.vue?vue&type=script&lang=js&"
export * from "./GyroscopeMaze.vue?vue&type=script&lang=js&"
import style0 from "./GyroscopeMaze.vue?vue&type=style&index=0&id=6310d924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310d924",
  null
  
)

export default component.exports